<p-tabView (onChange)="tabChanged($event)">
    <p-tabPanel header="This Month">
        <p-table [value]="itemsSummary" [loading]="loading" [rows]="5" [paginator]="false" [responsive]="true" dataKey="item">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 3rem"></th>
                    <th>Item</th>
                    <th>Quantity</th>
                    <th>Amount</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-expanded="expanded">
                <tr>
                    <td>
                        <button type="button" pButton pRipple
                                [pRowToggler]="item"
                                class="p-button-text p-button-rounded p-button-plain"
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                [disabled]="getAccountDetailsForItem(item.item, 'current').length === 0">
                        </button>
                    </td>
                    <td>{{ item.item }}</td>
                    <td>{{ item.qty }}</td>
                    <td>{{ item.amount | currency:'USD' }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-item>
                <tr>
                    <td colspan="4">
                        <div class="p-3">
                            <h5>Accounts for {{ item.item }}</h5>
                            <p-table [value]="getAccountDetailsForItem(item.item, 'current')" dataKey="id">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Contact Name</th>
                                        <th>Amount</th>
                                        <th>Termination Date</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-contact>
                                    <tr>
                                        <td>{{ contact.contactName }}</td>
                                        <td>{{ contact.rate_amount | currency:'USD' }}</td>
                                        <td>{{ contact.terminationDates | date:'short' || 'Active' }}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>

        <h3>Invoice Total (This Month): <span>{{ itemsTotal | currency }}</span></h3>
    </p-tabPanel>
    <p-tabPanel header="Next Month">
        <p-table [value]="itemsSummaryNextMonth" [loading]="loading" [rows]="5" [paginator]="false" [responsive]="true" dataKey="item">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 3rem"></th>
                    <th>Item</th>
                    <th>Quantity</th>
                    <th>Amount</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-expanded="expanded">
                <tr>
                    <td>
                        <button type="button" pButton pRipple
                                [pRowToggler]="item"
                                class="p-button-text p-button-rounded p-button-plain"
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                [disabled]="getAccountDetailsForItem(item.item, 'next').length === 0">
                        </button>
                    </td>
                    <td>{{ item.item }}</td>
                    <td>{{ item.qty }}</td>
                    <td>{{ item.amount | currency:'USD' }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-item>
                <tr>
                    <td colspan="4">
                        <div class="p-3">
                            <h5>Accounts for {{ item.item }}</h5>
                            <p-table [value]="getAccountDetailsForItem(item.item, 'next')" dataKey="id">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Contact Name</th>
                                        <th>Amount</th>
                                        <th>Termination Date</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-contact>
                                    <tr>
                                        <td>{{ contact.contactName }}</td>
                                        <td>{{ contact.rate_amount | currency:'USD' }}</td>
                                        <td>{{ contact.terminationDates | date:'short' || 'Active' }}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>

        <h3>Invoice Total (Next Month): <span>{{ itemsTotalNextMonth | currency }}</span></h3>
    </p-tabPanel>
</p-tabView>